import { render, staticRenderFns } from "./haibaoShop.vue?vue&type=template&id=01ac2238&"
import script from "./haibaoShop.vue?vue&type=script&lang=js&"
export * from "./haibaoShop.vue?vue&type=script&lang=js&"
import style0 from "./haibaoShop.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports